export default __webpack_public_path__ + "static/media/supljivaljak.d3dd0674.jpg";